import {forwardRef} from 'react'
import Slide from '@mui/material/Slide'


const SlideTransition = forwardRef((props, ref) => (
  <Slide direction='up' ref={ref} {...props} />
))


export default SlideTransition